
import TableList from "@components/templates/tablelist";
import { HttpGetSummarylist, HttpDeleteOneSummaryLog } from "@/service/aftersales/aftersales";
import { mapState,mapGetters } from "vuex";
import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            erpSkusList:[],
            category:'',
            issueTypes:{
                "":[],
                "PRESALE_CONSULTING":[
                    {value:'DELIVERY',name:'Delivery'},
                    {value:'PAYMENT',name:'Payment'},
                    {value:'PRODUCT_INFORMATION',name:'Product Information'},
                    {value:'COUPON_CODE',name:'Coupon Code'},
                    {value:'INVENTORY',name:'Inventory'},
                    {value:'CUSTOMER_INQUIRY_FOR_PACKAGE',name:'Customer Inquiry for Package'},
                    {value:'CUSTOMER_INQUIRY_FOR_COMPANY',name:'Customer Inquiry for Company'},
                    {value:'WARRANTY',name:'Warranty'},
                ],
                "PURCHASING":[
                    {value:'SHIPPING_TIME',name:'Shipping time'},
                    {value:'CANCEL_ORDER',name:'Cancel order'},
                    {value:'CHANGE_ADDRESS',name:'Change address'},
                    {value:'ORDER_INFORMATION_CONFIRM',name:'Order information Confirm'},
                    {value:'OUT_OF_STOCK',name:'Out of stock'},
                    {value:'NOT_RECEIVED',name:'Not received'},
                ],
                "POST_SALE_CONSULTING":[
                    {value:'DOA',name:'DOA'},
                    {value:'MISSING_PARTSORPARTS_DAMAGED',name:'Missing parts/Parts damaged'},
                    {value:'WRONG_DELIVERY',name:'Wrong Delivery'},
                    {value:'FBA_ISSUE',name:'FBA issue'},
                    {value:'BUYER_REMORSE',name:'Buyer Remorse'},
                    {value:'TROUBLE_SHOOTING',name:'Trouble Shooting'},
                    {value:'QUALITY_ISSUE_NOT_AFFECT_USE',name:'Quality Issue(Not affect use)'},
                    {value:'QUALITY_ISSUE_CAN_NOT_USE',name:'Quality Issue(can not use)'},
                    {value:'Product Dose Not Meet Customer Expectation',name:'product dose not meet customer expectation'},
                ]
            },
            
            initData:'',
        };
    },
    methods: {
        ajaxRequest: HttpGetSummarylist,
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(type!='addnewpage'){
                if(batch){
                    params=(params||this.checkedData.join(','))+'';
                    if(!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                }
            }
            switch (type) {
                case "addnewpage":
                    this.$router.push({
                        name: 'updateAfterCustomer',
                        params: { type: "add" },
                        query: { custype: 'cus' },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'updateAfterCustomer',
                        params: { type: "edit" },
                        query: { id: params,custype: 'cus' },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.operation_see',{defaultValue:'查看'}),
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:params,
                        querytype:'query',
                        operacustype:'cus',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "updateAfterCustomer",
                        params: { type: "query" },
                        query: { id: params,custype: 'cus' },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "b2cquery":
                    var url=this.$router.resolve({
                        name: "b2cOrderupdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "failure":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{ids:params},
                        title: this.$t('erp.aftersales.failures',{defaultValue:'批量失效操作'}),
                        ajaxRequest:HttpFailureWarehouse
                    }
                    break;
                case "delete":
                    this.operate={
                        show: true,
                        alert: "error",
                        params:{id:params},
                        title: this.$t('fbb.reserveinbound.delete',{defaultValue:'删除操作'}),
                        ajaxRequest:HttpDeleteOneSummaryLog
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.alloment.import_data',{defaultValue:'导入数据'}),
                        width:460,
                        showFooter: false,
                        data: { contextId: global.SYSID},
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/serviceSummary/importSummary",
                        name: "excelFile",
                        component: "compUpload",
                        download:this.downloadExcel
                    };
                    break;
                case 'export':
                    if(this.total>2000){
                        this.$VMessage.error(this.$t('erp.b2c.alert_morethanother',{defaultValue:'导入数据'}) + '2000');
                    }else{
                        // const formData=this.interceptRequest({search:{...this.formData.search}});
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/serviceSummary/export',this.formData,{
                            executor: 'request',
                            download: true,
                        }).catch(err => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                        });
                    }
                    break;
                
            }
        },
        downloadExcel(){
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/serviceSummary/summaryTemplate", {}, 'download') 
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id, issueStatus } = row
            return [{
                label:this.$t('global.common.query',{defaultValue:'查看'}),
                show:true,
                params:id,
                operate:'query'
            },{
                label:this.$t('global.common.edit',{defaultValue:'编辑'}),
                show:issueStatus=='INPROCESS',
                // params:id,
                // operate:'edit'
                to: {
                    name: 'updateAfterCustomer',
                    params: { type: 'edit'},
                    query: { id , custype: 'cus' },
                },
            },{
                label:this.$t('global.common.delete',{defaultValue:'删除'}),
                show:issueStatus=='INPROCESS',
                params:id,
                operate:'delete'
            }]
        },
        dedupe(array) {
			var temp = []; //一个新的临时数组
			for(var i = 0; i < array.length; i++){
				if(temp.indexOf(array[i]) == -1){
					temp.push(array[i]);
				}
			}
			return temp;
		},
    },
    computed: {
        // ...mapState('boss', ['accounts','products']),
        ...mapGetters('diction',['getNewProductList','getNewAccountList']),
        options() {
            return {
                shortcuts: [
                    {text: this.$t("global.common.latest_week",{defaultValue:'最近一周'}),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        }
                    },
                    {text: this.$t("global.common.recent_month",{defaultValue:'最近一月'}),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        }
                    },
                    {text: this.$t("global.common.latest_quarter",{defaultValue:'最近一季度'}),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        }
                    }
                ]
            }
        }, 
        accountsAll(){
            return this.getNewAccountList.sort(function(a,b){
                return a.value.localeCompare(b.value)
            })
        },
        // table中单据状态的按钮展示
        orderStatus(){
            return [
                {
                    value: '0',
                    label: this.$t('global.common.effective',{defaultValue:'有效'}),
                    theme:'info',
                },
                {
                    value: '1',
                    label: this.$t('global.common.failure',{defaultValue:'失效'}),
                    theme:'error',
                }, 
            ];
        },
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: this.$t('erp.product.new_add',{defaultValue:'添加'}),
                    operate: "addnewpage",
                    theme: "primary",
                    batch:true,
                },
                {
                    name: this.$t('global.common.import',{defaultValue:'导入'}),
                    operate: "import",
                    // theme: "success",
                    more:true
                },
                {
                    name: this.$t('erp.b2c.condition_export',{defaultValue:'查询条件导出'}),
                    operate: "export",
                    more:true
                }
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            const dropStyle="width:auto;";
            return  [
                {
                    label: this.$t('erp.aftersales.orderNum',{defaultValue:'单据号'}),
                    tag:'vInput',
                    key: 'EQ_serviceSummaryNo',
                    show:true,
                },
                {
                    label: this.$t('erp.b2c.channel_account',{defaultValue:'渠道账号'}),
                    tag: 'vSelect',
                    key: 'EQ_sourceChannel',
                    show:true,
                    options:this.accountsAll,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "Issue Category",
                    tag: 'vSelect',
                    key: 'EQ_issueCategory',
                    show:true,
                    on:{
                        'on-change':(val)=>{
                            // console.log(val)
                            this.category = val
                        }
                    },
                    options: [
                        {
                            value: 'PRESALE_CONSULTING',
                            label: 'Presale Consulting'
                        },
                        {
                            value: 'PURCHASING',
                            label: 'Purchasing'
                        },
                        {
                            value: 'POST_SALE_CONSULTING',
                            label: 'Post-Sale Consulting'
                        },
                    ],
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getNewProductList,
                    style: "width:180px",
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "Seller SKU",
                    tag: 'vInput',
                    key: 'EQ_sellerSku',
                    style: "width:180px",
                },
                {
                    label: "Issue Status",
                    tag: 'vSelect',
                    key: 'EQ_issueStatus',
                    options: [
                        {
                            value: 'INPROCESS',
                            label: 'Inprogress '
                        },
                        {
                            value: 'FINISHED',
                            label: 'Done'
                        },
                    ],
                    style: "width:180px",
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: "AssignedTo",
                    tag: 'vInput',
                    key: 'CN_assignedTo',
                    style: "width:180px",
                },
                {
                    label: this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
                    tag: 'vInput',
                    key: 'EQ_orderNo',
                    style: "width:180px",
                },
                {
                    label: this.$t('global.common.email',{defaultValue:'邮箱'}),
                    tag: 'vInput',
                    key: 'EQ_orderEmail',
                    style: "width:180px",
                },
                {
                    label: "Issue Type",
                    tag: 'vSelect',
                    key: 'EQ_issueType',
                    options:this.issueTypes[this.category].map(function(item){
                        // console.log(item)
                        const {value,name} = item;
                        return {
                            value: value,
                            label: name
                        }
                    }),
                    style: "width:180px",
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: "width:180px",
                },
                
            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: this.$t('global.common.actions',{defaultValue:'操作'}),
                width: 70,
                render:this.getOperateNodes
            }, 
            {
                title: this.$t('erp.aftersales.orderNum',{defaultValue:'单据号'})+'/'+this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
                sortable: true,
                render:(h,{row})=>{
                    return <div>
                        <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.serviceSummaryNo}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                        <div><a onClick={this.handleOperates.bind(this, row.orderId, 'b2cquery')}>{row.orderNo}</a></div>
                        </div>
                }
            },
            {
                title: 'Issue Status',
                width:100,
                sortable: true,
                render:(h,{row})=>{
                    let status;
                    switch(row.issueStatus){
                        case 'INPROCESS': return <vButton class="b2cspan-info span-padding">Inprogress</vButton>;break;
                        case 'FINISHED': return <vButton class="b2cspan-light-content span-padding">Done</vButton>;break;
                    }
                }
            },
            
            {
                title: this.$t('global.common.project',{defaultValue:'项目'})+'/'+this.$t('erp.b2c.channel_account',{defaultValue:'渠道账号'})+'/Seller SKU',
                // key: 'lineId',
                sortable: true,
                render:(h, { row })=>{
                    const id = row.lineId;
                    const product = this.getNewProductList.filter((item) => {
                        return id == item.value
                    })[0] || {};
                    return <div>
                        <div>{product.label}</div>
                        <div>{row.sourceChannel}</div>
                        <div>{row.sellerSku}</div>
                    </div>
                }
            },
            {
                title: 'Issue Category/Type',
                // key: 'issueCategory',
                render:(h,{row})=>{
                    let issueCategory;
                    switch(row.issueCategory){
                        case 'PRESALE_CONSULTING': issueCategory = 'Presale Consulting';break;
                        case 'PURCHASING': issueCategory = 'Purchasing';break;
                        case 'POST_SALE_CONSULTING': issueCategory = 'Post-Sale Consulting';break;
                    }
                    let issueType = this.issueTypes[row.issueCategory].map(item=>{
                        if(row.issueType == item.value){
                            return item.name
                        }
                    })
                    return <div>
                        <div>{issueCategory}</div>
                        <div>{issueType}</div>
                    </div>
                },
                sortable: true
            },
            {
                title: this.$t('global.common.email',{defaultValue:'邮箱'})+'/'+'AssignedTo',
                render:(h,{row})=>{
                    return <div>
                    <div>{row.orderEmail}</div>
                    <div>{row.assignedTo}</div>
                    </div>
                }
            },
            {
                title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                key: 'updatedAt',
                sortable: true
            },
        ];
        },
        
    },

};
